<template>
  <div>
    <paymentHeader
      :hasPermission="hasPermission"
      :activeTabProp="activeSubTab"
      @switchTab="switchSubTab"
      :viewFilter="viewFilter"
      :viewAdd="viewAdd"
    />
    <div v-if="activeSubTab == 'posting'">
      <paymenttable
        :accountPosting="accountPosting.data"
        :hasPermission="hasPermission"
        :loading="loading"
        :viewPosting="viewPosting"
        :authorize="authorize"
        :attemptReverse="attemptReverse"
        :initiatePrintReceipt="initiatePrintReceipt"
      />
      <Pagination
        :limit="accountPosting.pageSize"
        :count="accountPosting.pageCount"
        :page="accountPosting.pageNumber"
        :itemsCount="accountPosting.count"
        @changePage="gotoPage"
        @changeLimit="changeLimit"
      />
    </div>
    <div v-if="activeSubTab == 'methods'">
      <paymentMethod />
    </div>
    <div v-if="activeSubTab == 'notify'">
      <PaymentNotification />
    </div>
    <filter-posting @onFilterClear="onFilterClearHandler" />
    <view-payment
      :data="posting"
      :closeModal="closeModal"
      v-if="isModalVisible"
    />
    <add-account-posting
      @onPostAccountComplete="onPostAccountCompleteHandler"
      @onPostAccountCancel="onPostAccountCancelHandler"
    />
    <reverse-note @onReverseProceed="onReverseProceedHandler" />
    <AccountPostingReceipt
      :receiptData="singlePosting"
      :isPostPaymentPage="false"
    />
  </div>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import { helper } from "@/helper";
import SystemPermissions from "@/permissions";
import ViewPayment from "../../components/Payment/ViewPayment.vue";
import FilterPosting from "../../components/Posting/FilterPosting.vue";
import AddAccountPosting from "../../components/Posting/AddAccountPosting.vue";
import Pagination from "../../components/Pagination.vue";
import { mapActions, mapGetters } from "vuex";
import AccountPostingReceipt from "../../components/Posting/AccountPostingReceipt.vue";
import AccountPostingCheckbox from "../../components/Posting/AccountPostingCheckbox.vue";
import ReverseNote from "../../components/Posting/ReverseNote.vue";
import paymentHeader from "../../components/ManagePayment/paymentHeader.vue";
import paymenttable from "../../components/ManagePayment/paymenttable.vue";
import paymentMethod from "../../components/ManagePayment/paymentMethod.vue";
import PaymentNotification from "../../components/ManagePayment/PaymentNotification.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  components: {
    FilterPosting,
    AddAccountPosting,
    ViewPayment,
    AccountPostingCheckbox,
    ReverseNote,
    Pagination,
    AccountPostingReceipt,
    paymentHeader,
    paymenttable,
    paymentMethod,
    PaymentNotification,
  },

  data() {
    return {
      isBusy: false,
      activeSubTab: "posting",
      isModalVisible: false,
      // loading: true,
      count: 0,
      page: 0,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      posting: {
        owner: {
          displayName: "",
        },

        maker: {
          displayName: "",
        },

        paymentChannel: {
          paymentChannelTypeName: "",
        },

        authorizedBy: {
          displayName: "",
        },
      },
      selectedPayments: [],
      isAuthorizeLoading: false,
      reverseId: "",
      singlePosting: {},
    };
  },

  created() {
    this.getAccountPostings();
  },

  computed: {
    ...mapGetters(["accountPosting", "accountPostingFilter"]),
    loading() {
      return this.$store.state.loading;
    },
    user: function() {
      return this.$store.state.currentUser;
    },
  },

  methods: {
    ...mapActions(["getAccountPostings"]),
    switchSubTab(subTab) {
      this.activeSubTab = subTab;
    },
    printReceipt() {
      const prtHtml = document.getElementById("paymentReceipt").innerHTML;
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      const WinPrint = window.open("", "_blank", "");

      WinPrint.document.write(`<!DOCTYPE html>
                <html>
                  <head>
                    ${stylesHtml}
                    <style>
                        @font-face{
                        font-family:feather;
                        src:url(../assets/fonts/feather/fonts/feather.eot?t=1525787366991);
                        src:url(../assets/fonts/feather/fonts/feather.eot?t=1525787366991#iefix) format('embedded-opentype'),
                        url(../assets/fonts/feather/fonts/feather.woff?t=1525787366991) format('woff'),
                        url(../assets/fonts/feather/fonts/feather.ttf?t=1525787366991) format('truetype'),
                        url(../assets/fonts/feather/fonts/feather.svg?t=1525787366991#feather) format('svg')
                        }
                        html *
                        {
                           font-family: Sans-Serif, Arial !important;
                        }
                    </style>
                  </head>
                  <body>
                    ${prtHtml}
                  </body>
                </html>`);

      WinPrint.print();
    },

    formatDate(date) {
      return moment(date).format("ll");
    },

    viewAdd() {
      $("#mod-add-posting").modal("show");
    },

    viewFilter() {
      this.accountPosting.pageNumber = 0;
      this.updateFilter(this.accountPosting);
      $("#mod-account-posting-filter").modal("show");
    },

    onFilterClearHandler() {
      $("#mod-account-posting-filter").modal("hide");
      this.getAccountPostings();
    },

    prepareDetail(value) {
      const name = value.paymentChannelTypeName;
      let result = "";
      if (name) {
        result += name;
        if (name.toLowerCase() === "bank") {
          result += "/ " + value.bankName + "/ " + value.accountNumber;
        } else if (name.toLowerCase() === "pos") {
          result += "/ " + value.bankName + "/ " + value.terminalId;
        } else if (name.toLowerCase() === "cryptocurrency") {
          result += "/ " + value.bankName + "/ " + value.walletAddress;
        }
      }
      return result;
    },

    viewPosting(data) {
      this.posting = data;
      this.isModalVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.isModalVisible = false;
      document.body.style.overflow = "auto";
    },

    async initiatePrintReceipt(id) {
      const singlePosting = this.accountPosting.data.find((el) => el.id === id);
      this.singlePosting = singlePosting;
      setTimeout(this.printReceipt, 1000);
    },
    async authorize(id) {
      this.isBusy = true;
      try {
        const response = await this.$http.put(
          `/AccountPosting/authorize/${id}`
        );
        if (response.ok) {
          this.$toast.success(response.body, {
            icon: false,
            rtl: false,
          });
          $("#mod-authorize-success").modal("show");
          this.accountPosting.data = [];
          this.getAccountPostings();
        }
      } catch (error) {}
      this.isBusy = false;
    },

    attemptReverse(value) {
      this.reverseId = value;
      $("#mod-reverse-note").modal("show");
    },

    async onReverseProceedHandler(notes) {
      $("#mod-reverse-note").modal("hide");
      await this.reverse(notes);
    },

    async reverse(notes) {
      this.isBusy = true;
      try {
        const response = await this.$http.put(
          `/AccountPosting/reverse/${this.reverseId}`,
          {
            notes: notes,
          }
        );
        if (response.ok) {
          this.$toast.success(response.body, {
            icon: false,
            rtl: false,
          });
          this.reverseId = "";
          this.accountPosting.data = [];
          this.getAccountPostings();
        }
      } catch (error) {
        console.log(error);
      }
    },

    onPostAccountCompleteHandler() {
      this.accountPosting.data = [];
      this.getAccountPostings();
      $("#mod-add-posting").modal("hide");
    },

    onPostAccountCancelHandler() {},

    onPaymentRemoveHandler(value) {
      this.selectedPayments = this.selectedPayments.filter((x) => x != value);
    },

    onPaymentAddHandler(value) {
      this.selectedPayments.push(value);
    },

    async authorizeList() {
      if (this.selectedPayments.length > 0) {
        this.isAuthorizeLoading = true;
        this.isBusy = true;

        try {
          const response = await this.$http.put(
            "/AccountPosting/authorize",
            this.selectedPayments
          );

          if (response.ok) {
            this.$toast.success(response.body, {
              icon: false,
              rtl: false,
            });

            this.getAccountPostings();
            this.selectedPayments = [];
          }
        } catch (error) {}
        this.isAuthorizeLoading = false;
        this.isBusy = false;
      }
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },

    goToPayment(id) {
      this.$router.push("/payments/" + id);
    },

    updateFilter(filter) {
      this.$store.commit("updateAccountPosting", filter);
    },

    prev() {
      this.accountPosting.pageNumber -= 1;
      this.getAccountPostings();
    },

    next() {
      this.accountPosting.pageNumber += 1;
      this.getAccountPostings();
    },

    gotoPage(page) {
      this.accountPosting.pageNumber = page;
      this.getAccountPostings();
    },

    changeLimit(limit) {
      this.accountPosting.pageSize = limit;
      this.pageNumber = 1;
      this.getAccountPostings();
    },
  },
};
</script>
